var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 118.202,
    height: 118.203,
    viewBox: "0 0 118.202 118.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.807,
    y1: 0.201,
    x2: 0.215,
    y2: 0.878,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.251
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-2990.9,2021.2a58.734,58.734,0,0,1-23.005-4.644,58.906,58.906,0,0,1-18.786-12.666,58.907,58.907,0,0,1-12.666-18.786A58.732,58.732,0,0,1-3050,1962.1a58.731,58.731,0,0,1,4.644-23.005,58.9,58.9,0,0,1,12.666-18.786,58.906,58.906,0,0,1,18.786-12.666A58.733,58.733,0,0,1-2990.9,1903a58.733,58.733,0,0,1,23,4.644,58.905,58.905,0,0,1,18.786,12.666,58.908,58.908,0,0,1,12.666,18.786,58.731,58.731,0,0,1,4.644,23.005,58.732,58.732,0,0,1-4.644,23.005,58.908,58.908,0,0,1-12.666,18.786,58.905,58.905,0,0,1-18.786,12.666A58.733,58.733,0,0,1-2990.9,2021.2Zm-23.165-83.919a22.045,22.045,0,0,0-16.791,7.426,26.128,26.128,0,0,0-6.217,17.392,26.129,26.129,0,0,0,6.217,17.393,22.029,22.029,0,0,0,15.657,7.4,3.637,3.637,0,0,0,1.133.184c7.021,0,13.308-3.285,18.685-9.764a57.717,57.717,0,0,1-3.839-6.93,26.453,26.453,0,0,1-6.164,6.5,14.729,14.729,0,0,1-8.682,2.955,3.642,3.642,0,0,0-.943.129,15.461,15.461,0,0,1-6.089-1.59,15.147,15.147,0,0,1-4.79-3.771,17.232,17.232,0,0,1-3.135-5.556,21.173,21.173,0,0,1-1.124-6.947c0-10.367,6.763-17.892,16.082-17.892a14.55,14.55,0,0,1,8.5,2.89,26.945,26.945,0,0,1,6.186,6.4,45.287,45.287,0,0,1,5.21,9.736,48.892,48.892,0,0,0,6.6,12.365c5.6,7.51,12.274,11.318,19.833,11.318a22.042,22.042,0,0,0,16.791-7.426,26.131,26.131,0,0,0,6.217-17.393,26.13,26.13,0,0,0-6.217-17.392,22.027,22.027,0,0,0-15.657-7.4,3.637,3.637,0,0,0-1.133-.184c-6.946,0-13.233,3.35-18.687,9.958a59.858,59.858,0,0,1,3.855,6.9,27.5,27.5,0,0,1,6.209-6.6,14.492,14.492,0,0,1,8.622-3.014,3.6,3.6,0,0,0,.944-.13,15.465,15.465,0,0,1,6.089,1.59,15.154,15.154,0,0,1,4.79,3.771,17.231,17.231,0,0,1,3.135,5.556,21.172,21.172,0,0,1,1.124,6.947c0,10.367-6.763,17.892-16.081,17.892a14.855,14.855,0,0,1-8.705-2.937,26.42,26.42,0,0,1-6.194-6.478,43.526,43.526,0,0,1-4.983-9.575l-.017-.05a50.551,50.551,0,0,0-6.629-12.2C-2999.946,1941.143-3006.608,1937.283-3014.064,1937.283Z",
    transform: "translate(3050 -1903)",
    fill: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllAccess);
export default __webpack_public_path__ + "static/media/allAccess.fd4edb726994f68578302b3b62702986.svg";
export { ForwardRef as ReactComponent };